
class RegisterForm extends HTMLElement {
  constructor() {
    super();
    this.showPassBtn = this.querySelector('.js-action-pass-switch-type-btn');
    this.button = this.querySelector('button[type="submit"]');
    this.form = this.querySelector('form');
    this.readTermsOfService = false;
    this.readPrivacyPolicy = false;
    this.btnsSearchZip = this.querySelectorAll('.efo-search-address');
    this.inputZip = this.querySelectorAll('.efo-input-zip');

    this.scrollTerms = this.querySelectorAll('.scroll_read_term');
    this.policyAgreement = this.querySelector('input[name="privacy_agreement"]');
    this.inputCompany = this.querySelector('input[name="company"]');
    this.passwordInput = this.querySelector('input[name="register_info[password]"]');
    this.confirmPassword = this.querySelector('input[name="register_info[confirm_password]"]');
    this.variantNames = this.querySelectorAll('.product-ink-link');
    this.emailInput = this.querySelector('input[name="email');
    this.phoneInput = this.querySelector('[name="phone"]');
    // this.faxInput = this.querySelector('[name="fax"]');
    this.emailValidate = false;

    this.closeModals = this.querySelectorAll('.close');
    this.popupOverlay = this.querySelector('#popupOverlay');
    this.efoInputRowUsageSubscription = this.querySelector('#efoInputRowUsageSubscription');
    this.notificationServiceUse = this.querySelector('#notificationServiceUse');
    this.requiredInputs = this.querySelectorAll('[data-required="cartridge-required"]')
    this.apiDomain = window.appDomain;
    this.modalPreview = this.querySelector('.modal-register-preview');
    this.buttonPreview = this.querySelector('.button-preview');
    this.closePreviews = this.querySelectorAll('.close-preview');
    this.returnTo = this.querySelector('[name="return_to"]')
    this.key = CryptoJS.enc.Utf8.parse('VxYe84B7zSj4PHsr'); // 16 ký tự
    this.iv = CryptoJS.enc.Utf8.parse('eLyUW4vttpvQdZsf');  // 16 ký tự
    this.hideUsageSubscription();
    this.setupEventListeners();
    this.extractTokenData();
  }

  hideUsageSubscription() {
    if (this.efoInputRowUsageSubscription) {
      this.efoInputRowUsageSubscription.style.display = 'none';
    }
    this.querySelectorAll('#efoInputRowUsageSubscription input').forEach(el => {
      el.removeAttribute('data-required');
      el.classList.remove('required', 'register-required', 'input-for-preview');
    });
  }

  extractTokenData() {
    if (location.search != "") {
      const encryptedText = location.search.replace('?', '');
      const decrypt = decryptAES128CBC(encryptedText, this.key, this.iv);

      decrypt.split('&').forEach(param => {
        const entries = param.split('=');
        const key = entries[0].trim().toLowerCase();
        const value = entries[1];
        this.querySelectorAll(`[data-key="${key}"]`).forEach(input => {
          if (input.type === 'checkbox') {
            input.checked = value === '1';
          } else {
            input.value = value
          }
        })
      })
    }
  }

  setupEventListeners() {

    this.querySelectorAll('input[type="radio"]').forEach(input => {
      input.addEventListener('change', (e) => {
        const name = e.target.name;
        this.querySelectorAll(`[name="${name}"]`).forEach(element => {
          element.classList.remove('warning')
        })
      })
    })

    this.addRequiredEvent()
    this.btnsSearchZip.forEach(btn => {
      btn.addEventListener('click', this.searchAddress.bind(this));
    });

    this.buttonPreview.addEventListener('click', e => {
      if (this.modalPreview.classList.contains('open')) {
        this.modalPreview.classList.remove('open')
        document.body.classList.remove('overflow-hidden');
      } else {
        document.body.classList.add('overflow-hidden');
        this.modalPreview.classList.add('open')
      }
    });

    this.closePreviews.forEach(btn => {
      btn.addEventListener('click', e => {
        document.body.classList.remove('overflow-hidden');
        this.modalPreview.classList.remove('open')
      })
    })


    this.inputZip.forEach(input => {
      input.addEventListener('blur', this.enterZip.bind(this));
      input.addEventListener('change', this.enterZip.bind(this));
      input.addEventListener('keyup', this.enterZip.bind(this));
    });

    this.querySelectorAll('input').forEach(input => {
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      })
    })

    // this.faxInput.addEventListener('change', this.validateFaxHandler.bind(this))
    // this.faxInput.addEventListener('keyup', this.validateFaxHandler.bind(this))

    this.form.addEventListener('submit', this.submit.bind(this));

    this.scrollTerms.forEach(e => {
      e.addEventListener('scroll', this.scrollTermsOfService.bind(this));
    })

    this.querySelectorAll('.input_name').forEach(input => {
      const furiganaInputId = input.dataset.furigana;
      input.addEventListener('keyup', (e) => {
        if (this.querySelector(`#${furiganaInputId}`)) {
          this.querySelector(`#${furiganaInputId}`).dispatchEvent(new Event('change'))
        }
      })
      input.addEventListener('change', (e) => {
        if (this.querySelector(`#${furiganaInputId}`)) {
          this.querySelector(`#${furiganaInputId}`).dispatchEvent(new Event('change'))
        }
      })
    })

    //validate password
    this.querySelectorAll('.input_password').forEach(input => {
      input.addEventListener('change', this.validatePasswordHandler.bind(this))
      input.addEventListener('keyup', this.validatePasswordHandler.bind(this))
    })

    // add event validate phone number
    this.querySelectorAll('.phone_input').forEach(input => {
      input.addEventListener('change', this.validatePhoneHandler.bind(this))
      input.addEventListener('keyup', this.validatePhoneHandler.bind(this))
    })
    // validate email
    this.querySelectorAll('[name="email"]').forEach(input => {
      input.addEventListener('change', this.validateEmailHandler.bind(this))
      input.addEventListener('keyup', this.validateEmailHandler.bind(this))
      input.addEventListener('change', this.validateAccount.bind(this))
      // input.addEventListener('input', debounce(this.validateAccount.bind(this), ON_INPUT_DEBOUNCE_TIMER))
    })

    this.phoneInput.addEventListener('blur', this.validatePhoneHandler.bind(this))


    // validate furigana
    this.querySelectorAll('.furigana_name').forEach(input => {
      input.addEventListener('change', this.validateFuriganaHandler.bind(this))
    })
    // toggle show password
    this.querySelectorAll('.js-action-pass-switch-type-btn').forEach(input => {
      input.addEventListener('click', this.showPassword.bind(this))
    })
    // validate job 
    this.querySelectorAll('[name="job"]').forEach(input => {
      input.addEventListener('change', this.validateJobHandler.bind(this))
    })

    // add event click open modal when click 
    this.variantNames.forEach(variant => {
      const value = variant.dataset.variant
      variant.addEventListener('click', e => {
        this.openModalAbout(value)
      })
    })


    // close modal event
    this.closeModals.forEach(closeModal => {
      closeModal.addEventListener('click', () => {
        closeModal.parentElement.parentElement.classList.add('hidden');
      })
    })

    //close modal using button 
    this.querySelectorAll('.close-second').forEach(button => {
      button.addEventListener('click', () => {
        const target = this.querySelector(`#${button.dataset.target}`);
        target.classList.add('hidden');
      })
    })

    //open/close popup question
    this.querySelectorAll('.openPopupQuestion').forEach(button => {
      button.addEventListener('click', () => {
        this.popupOverlay.classList.remove('hidden');
      })
    })
    this.querySelectorAll('.close-popup').forEach(button => {
      button.addEventListener('click', () => {
        this.popupOverlay.classList.add('hidden');
      })
    })

    // validate notification
    this.querySelectorAll('[name="notification_service_flg"]').forEach(input => {
      input.addEventListener('change', () => {
        if (input.value === 'TRUE' && input.checked) {
          this.notificationServiceUse.classList.remove('hidden');
          this.requiredInputs.forEach(input => {
            input.classList.add('required');
            input.addEventListener('change', this.validateRequiredInputHandler.bind(this));
          })
          this.querySelectorAll('[data-name="notification_service_flg-FALSE"]').forEach(input => {
            input.checked = false
          })
          this.querySelector('.preview-select-product').classList.remove('hidden')
        } else {
          this.notificationServiceUse.classList.add('hidden');
          this.requiredInputs.forEach(input => {
            input.classList.remove('required');
            input.removeEventListener('change', this.validateRequiredInputHandler.bind(this));
          })
          this.querySelectorAll('[data-name="notification_service_flg-TRUE"]').forEach(input => {
            input.checked = false
          })
          this.querySelector('.preview-select-product').classList.add('hidden')

        }
        this.validateForm()
      })
    })

    this.querySelectorAll('.input-for-preview').forEach(input => {
      input.addEventListener('change', this.changeValuePreview.bind(this))
    })

  }

  openModalAbout(value) {
    this.querySelectorAll('.modal-guide-item').forEach(m => {
      m.classList.add('hidden')
    })
    this.querySelectorAll(`.modal-guide-${value}`).forEach(m => {
      m.classList.remove('hidden')
    })
    this.querySelector('#modalAboutRegister').classList.remove('hidden');
    this.querySelector('#modalAboutRegister').classList.add('show');
  };

  addRequiredEvent() {
    this.querySelectorAll('.required:not(.furigana_name)').forEach(input => {
      input.addEventListener('change', this.validateRequiredInputHandler.bind(this));
    });
  }

  /**
   * Updates the preview elements based on the input change event.
   * If the input type is 'radio' or 'checkbox', it synchronizes the checked state
   * of elements with the same data-name attribute. Otherwise, it updates the text
   * content of preview elements with the input's value.
   * 
   * @param {Event} e - The event object associated with the input change.
   */

  changeValuePreview(e) {
    let value = e.target.value;
    const name = e.target.getAttribute('name');
    const target = e.target;
    const inp = ['radio', 'checkbox']
    const isSpecialInput = inp.includes(target.type)
    if (isSpecialInput) {
      const checkboxInputs = this.querySelectorAll(`[data-name="${name}-${value}"]`);
      if (target.type === 'radio') {
        const allElements = this.querySelectorAll(`[data-name^="${name}-"]`);
        allElements.forEach(element => {
          element.checked = false;
        });
      }
      checkboxInputs.forEach(element => {
        element.checked = e.target.checked;
      });
      return
    }
    if (name == 'register_info[age]' && value == "1") {
      value = '不明'
    }
    if (target.dataset.inputType === 'password') {
      value = '*'.repeat(value.length);
    }
    const previewElements = this.querySelectorAll(`[data-name="${name}"]`);
    previewElements.forEach(element => {
      element.textContent = value
    })
  }

  /**
   * Validate form, check all required fields have value and policy agree is checked
   * @returns {boolean} - true if all required fields have value and policy agree is checked, false otherwise
   */
  validateForm() {
    let isValid = true;
    const errors = Array.from(this.querySelectorAll('.required'))
      .map(field => {
        if (field.getAttribute('type') === 'radio') {
          if (field.checked) {
            return field.value
          } else {
            const name = field.getAttribute('name');
            return this.querySelector(`[name="${name}"]:checked`)?.value
          }
        }
        return field.value
      })
      .filter(value => !value || value === '')
    if (errors.length > 0) {
      isValid = false;
    }

    const inputs = Array.from(this.querySelectorAll('input'))
      .map(input => {
        const pTag = input.parentElement.querySelector('p')
        if (pTag?.classList.contains('error')) {
          return null
        }
        return 'Oke'
      })
      .filter(value => !value || value === '')

    if (inputs.length > 0) {
      isValid = false;
    }

    const formValid = isValid && this.readPrivacyPolicy && this.readTermsOfService && this.policyAgreement.checked && this.emailValidate
    if (formValid) {
      this.buttonPreview.removeAttribute('disabled')
      this.buttonPreview.querySelector('p').innerText = this.buttonPreview.dataset.enabled
    } else {
      this.buttonPreview.setAttribute('disabled', true)
      this.buttonPreview.querySelector('p').innerText = this.buttonPreview.dataset.disabled
    }
    return formValid;
  }

  /**
   * Show or hide notification error message for input element.
   * If validateResult is true, remove error state of the input element.
   * @param {Event} e - event object.
   * @param {boolean} validateResult - result of validation.
   * @param {string} message - error message.
   */
  showNotification(e, validateResult, message) {
    if (validateResult) {
      e.target.classList.remove('input-ng')
      e.target.parentElement.querySelector('p').classList.remove('error');
      e.target.parentElement.querySelector('p').innerText = ''
    } else {
      e.target.classList.add('input-ng')
      e.target.parentElement.querySelector('p').classList.add('error');
      e.target.parentElement.querySelector('p').innerText = message
    }
    this.validateForm();
  }

  /**
   * Handles the validation of individual phone number parts.
   * Determines the correct regex for the phone part based on its position (part 1, 2, or 3),
   * validates the part using the regex, and checks the full phone number.
   * Displays error notifications if validation fails.
   *
   * @param {Event} e - The event object associated with the input change.
   */
  validatePhoneHandler(e) {
    this.validateForm()
    const phoneNumber = e.target.value
    if (phoneNumber.includes('-')) {
      this.showNotification(e, false, 'ハイフンなしで入力してください。')
      return
    }
    const validatePhone = validatePhoneNumber(phoneNumber)
    this.showNotification(e, validatePhone, '有効な電話番号を入力してください。')
  }

  /**
   * Handles the validation of a fax number input.
   * Validates the fax number input using a regex and displays
   * an error notification if validation fails.
   * @param {Event} e - The event object associated with the input change.
   */
  validateFaxHandler(e) {
    const faxNumber = e.target.value
    if (faxNumber) {
      if (faxNumber.includes('-')) {
        this.showNotification(e, false, 'ハイフンなしで入力してください。')
      } else {
        const validatePhone = validatePhoneNumber(faxNumber)
        this.showNotification(e, validatePhone, '有効な電話番号を入力してください。')
      }
    } else {
      this.showNotification(e, true, '')
    }
    this.validateForm()
  }


  /**
   * Handles the validation of an email input.
   * Validates the email input using validator.isEmail() and displays
   * an error notification if validation fails.
   * @param {Event} e - The event object associated with the input change.
   */
  validateEmailHandler(e) {
    // https://github.com/validatorjs/validator.js/?tab=readme-ov-file 
    const validateEmail = validator.isEmail(e.target.value)
    this.showNotification(e, validateEmail, '不正なメールアドレスです。(例: sample@sample.com)')
  }

  validatePhoneHandler(e) {
    const phoneNumber = e.target.value
    if (phoneNumber.includes('-')) {
      this.showNotification(e, false, 'ハイフンなしで入力してください。')
      return
    }
    const validatePhone = validatePhoneNumber(phoneNumber)
    this.showNotification(e, validatePhone, '有効な電話番号を入力してください。')
  }

  validateAccount(e) {
    const email = this.emailInput.value
    const validateEmail = validator.isEmail(email)


    if (validateEmail) {
      fetch(`${this.apiDomain}/customer/checking`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      })
        .then(response => response.json())
        .then(body => {
          this.returnTo.value = '/pages/register-thanks'
          const { data } = body
          const inputs = this.querySelectorAll('[data-input-type="password"]');
          this.querySelectorAll('.email-error').forEach(element => {
            element.classList.add('hidden')
          })
          this.emailInput.classList.remove('input-ng')

          if (data.result) {
            this.emailValidate = false;
            this.querySelectorAll(`[data-info="${data.result}"`).forEach(element => {
              element.classList.remove('hidden')
            })

            switch (data.result) {
              case 'email_taken':
                this.emailInput.classList.add('input-ng')
                break;

              case 'phone_email_taken':
                this.emailInput.classList.add('input-ng')
                break;
              case 'email_guest':
                this.emailValidate = true
                this.returnTo.value = '/pages/register-thanks-confirm'
                inputs.forEach(input => {
                  input.classList.remove('required');
                  input.removeAttribute('data-required');
                  input.value = '';

                  input.removeEventListener('change', this.validatePasswordHandler.bind(this))
                  input.dispatchEvent(new Event('change'));

                })
                break;
            }

            inputs.forEach(input => {
              input.classList.remove('required');
              input.removeAttribute('data-required');
              input.removeEventListener('change', this.validateRequiredInputHandler.bind(this));
              input.parentElement.parentElement.parentElement.classList.add('hidden')
            })
            this.querySelector('#confirm_passwords_preview').classList.add('hidden')

          } else {
            this.emailValidate = true

            inputs.forEach(input => {
              input.classList.add('required');
              input.classList.add('input-ng')
              input.setAttribute('data-required', 'register-required');
              input.addEventListener('change', this.validateRequiredInputHandler.bind(this));
              input.addEventListener('change', this.validatePasswordHandler.bind(this))
              input.parentElement.parentElement.parentElement.classList.remove('hidden')
              if (input.value !== '') {
                input.dispatchEvent(new Event('change'))
              }
            })
            this.querySelector('#confirm_passwords_preview').classList.remove('hidden')

          }
          this.validateForm();

        })
    }
  }

  /**
   * Handles the validation of a password input.
   * Validates the password input using a regex and displays
   * an error notification if validation fails.
   * @param {Event} e - The event object associated with the input change.
   */
  validatePasswordHandler(e) {
    let validateResult = true;
    if (e.target.classList.contains('required')) {
      validateResult = passwordRegex.test(e.target.value)
    }
    this.showNotification(e, validateResult, '8文字以上16文字以下で半角英数字をそれぞれ1文字以上含んでください。使える記号は『 , . _ - / () {} 』')

    const password = this.passwordInput.value;
    const rePassword = this.confirmPassword.value;
    if (rePassword != '' && password !== rePassword) {
      this.confirmPassword.classList.add('input-ng')
      this.confirmPassword.parentElement.querySelector('p').classList.add('error');
      this.confirmPassword.parentElement.querySelector('p').innerText = '入力されたパスワードが一致しません。'
    } else if (rePassword != '' && password === rePassword) {
      this.confirmPassword.classList.remove('input-ng')
      this.confirmPassword.parentElement.querySelector('p').classList.remove('error');
      this.confirmPassword.parentElement.querySelector('p').innerText = ''
    }

  }

  /**
   * Handles the validation of a furigana input.
   * Validates the furigana input using a regex and displays
   * an error notification if validation fails.
   * @param {Event} e - The event object associated with the input change.
   */
  validateFuriganaHandler(e) {
    let validateResult = true;
    if (e.target.dataset.required == 'required') {
      validateResult = furiganaRegex.test(e.target.value)
      if (e.target.value === '') {
        e.target.classList.add('input-ng')
        // e.target.parentElement.querySelector('p').classList.add('error');
      }
      else if (validateResult && e.target.value !== '') {
        e.target.classList.remove('input-ng')
        e.target.parentElement.querySelector('p').classList.remove('error');
        e.target.parentElement.querySelector('p').innerText = ''
      } else if (!validateResult) {
        e.target.classList.add('input-ng')
        e.target.parentElement.querySelector('p').classList.add('error');
        if (e.target.value !== '') {
          e.target.parentElement.querySelector('p').innerText = '全角カタカナで入力してください'
        }
      }
    }

    this.validateForm();
  }


  /**
   * Handles the validation of a required input.
   * Validates the input by checking if it has a value and displays
   * an error notification if validation fails.
   * @param {Event} e - The event object associated with the input change.
   */
  validateRequiredInputHandler(e) {
    const validateResult = e.target.value !== '' ?? false

    this.showNotification(e, validateResult, '必須項目のため、入力してください。')
  }

  /**
   * Handles the validation of job input.
   * If the job is "法人", adds or removes the required attribute and icon from the company name input element.
   * @param {Event} e - The event object associated with the input change.
   */
  validateJobHandler(e) {
    const iconRequired = document.createElement('i');
    iconRequired.classList.add('icon-required');

    this.inputCompany.removeEventListener('change', this.validateRequiredInputHandler.bind(this))
    if (e.target.value === '法人') {
      this.inputCompany.classList.add('required');
      this.inputCompany.addEventListener('change', this.validateRequiredInputHandler.bind(this))
      if (this.querySelector('#companyName .efo-input-title .icon-required') == null) {
        this.querySelector('#companyName .efo-input-title').appendChild(iconRequired);
      }

      this.inputCompany.dispatchEvent(new Event('change'))
    } else {
      this.inputCompany.classList.remove('required', 'input-ng');
      this.querySelector('#companyName .efo-input-title i')?.remove()
      this.inputCompany.parentElement.querySelector('p').classList.remove('error');
      this.inputCompany.value = ''
    }
    this.changeValuePreview(e);
  }

  /**
   * Handles the scroll event for terms of service or privacy policy elements.
   * Marks the respective document as read if fully scrolled to the bottom.
   * Enables the policy agreement checkbox if both documents have been read.
   *P:
   * @param {Event} e - The scroll event associated with the terms or privacy policy element.
   */

  scrollTermsOfService(e) {
    const readAll = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight <= 40;

    if (readAll) {
      if (e.target.dataset.scrollType === 'terms-of-service') {
        this.readTermsOfService = true;
      } else if (e.target.dataset.scrollType === 'privacy-policy') {
        this.readPrivacyPolicy = true;
      }
    }

    if (this.readTermsOfService && this.readPrivacyPolicy) {
      this.policyAgreement.removeAttribute('disabled')
    }
  }

  getFormData() {
    let formData = {};
    for (let [key, value] of new FormData(this.form)) {
      const match = key.match(/(\w+)\[(\w*)\]/);
      if (match) {
        const [_, parentKey, childKey] = match;
        if (!formData[parentKey]) formData[parentKey] = {};
        formData[parentKey][childKey] = value;
      } else {
        if (!formData[key]) {
          formData[key] = value;
        } else if (Array.isArray(formData[key])) {
          formData[key].push(value);
        } else if (typeof formData[key] === 'string') {
          formData[key] = [formData[key]]
          formData[key].push(value);
        } else {
          formData[key] = value;
        }
      }
    }
    return formData;
  }

  loading(enable) {
    if (enable) {
      this.button.classList.add('loading');
      this.button.querySelector('.loading__spinner').classList.remove('hidden');
      this.button.setAttribute('disabled', true);
    } else {
      this.button.classList.remove('loading');
      this.button.querySelector('.loading__spinner').classList.add('hidden');
      this.button.removeAttribute('disabled');
    }
  }
  submit(e) {
    e.preventDefault();
    this.loading(true);
    let formData = this.getFormData();
    if (formData.register_as_member !== 'true') {
      delete formData.register_info;
    }

    if (Array.isArray(formData.hmk)) {
      formData.hmk = formData.hmk.join(',');
    }
    formData.fax = ''
    formData.marketing_state = 'SUBSCRIBED'

    fetch(`${this.apiDomain}/customer/create`,
      {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      }).then(response => response.json())
      .then(async data => {
        const { success, message } = data;

        if (!success) {
          throw new Error(message);
        }
        window.location.href = this.returnTo.value;
      })
      .then(() => {
        this.loading(false);
      })
      .catch(error => {
        alert(error.message);
      })
      .finally(() => {
        this.loading(false);
      })
  }

  showPassword(e) {
    this.querySelectorAll('.input_password').forEach(input => {
      if (input.type === 'password') {
        input.type = 'text';
        e.target.textContent = e.target.dataset.hide;
      } else {
        input.type = 'password';
        e.target.textContent = e.target.dataset.show;
      }
    })
  }

  /**
   * Searches for an address based on the provided postal code.
   * Utilizes the AjaxZip3 library to fetch and fill address fields
   * when a valid 7-digit postal code is entered.
   * Triggers change events on the province and address fields
   * to ensure any dependent logic is executed.
   *
   * @param {Event} event - The event object associated with the input change.
   */

  searchAddress(event) {
    const zip = event.currentTarget.dataset.zip;
    const province = event.currentTarget.dataset.province;
    const city = event.currentTarget.dataset.city;
    const zipValue = document.getElementById(zip).value.replace('-', '');
    if (zipValue.length === 7) {
      AjaxZip3.zip2addr(zip, '', province, city);
      setTimeout(() => {
        this.querySelector(`[name="${province}"]`).dispatchEvent(new Event('change'))
        this.querySelector(`[name="${city}"]`).dispatchEvent(new Event('change'))
      }, 500);
    }
  }

  enterZip(e) {
    const postcode = formatJapanesePostalCode(e.target.value)
    if (validator.isPostalCode(postcode, 'JP')) {
      e.target.value = postcode
      const zip = e.currentTarget.id;
      const province = e.currentTarget.dataset.province;
      const city = e.currentTarget.dataset.city;
      e.target.classList.remove('input-ng')
      AjaxZip3.zip2addr(zip, '', province, city, '', '', false)
      e.currentTarget.parentElement.querySelector('p').classList.remove('error');
      e.currentTarget.parentElement.querySelector('p').innerText = ''
      setTimeout(() => {
        this.querySelector(`[name="${province}"]`).dispatchEvent(new Event('change'))
        this.querySelector(`[name="${city}"]`).dispatchEvent(new Event('change'))
      }, 500)

    } else {
      e.currentTarget.parentElement.querySelector('p').classList.add('error');
      e.currentTarget.parentElement.querySelector('p').innerText = '半角数字・ハイフンなしで入力してください。'
      e.target.classList.add('input-ng')
    }
  }
}
customElements.define('register-form', RegisterForm);
